import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import NumberFormat from 'react-number-format';
import {printThisPage, formatDecimal} from '../../utils/ExportUtils';
import DownloadButtons from '../../components/PdfAndExcelDownloadButtons';
import {EXPORT_EXCEL_TRADES} from '../../constants/uri'
import * as DownloadUtils from "../../utils/downloadUtils";
import * as Globals from "../../constants/globals";
import {post, checkHttpStatus} from "../../utils/RestUtilsWithAxios";

/**
 * desc
 * @param a
 * @param b
 * @param orderBy
 * @return {number}
 */
function desc(a, b, orderBy) {
    if(orderBy !== 'tradeDate'){
        if (orderBy === 'amount' || orderBy === 'price' || orderBy === 'buyerFee') {
            if (b[orderBy] < a[orderBy]) {
                return -1;
            }
            if (b[orderBy] > a[orderBy]) {
                return 1;
            }
            return 0;
        } else {
            if(a[orderBy] == null && b[orderBy] != null)
                return 1;
            else if(a[orderBy] != null && b[orderBy] == null)
                return -1;
            else if (a[orderBy] == null && b[orderBy] == null)
                return 0;
            else
                return b[orderBy].toString().localeCompare(a[orderBy].toString());
        }
            
    }
    else {
        if(a[orderBy] == null && b[orderBy] != null)
            return 1;
        else if(a[orderBy] != null && b[orderBy] == null)
            return -1;
        else if (a[orderBy] == null && b[orderBy] == null)
            return 0;
        else{
            const dateIndices = [ 6, 7, 8, 9, 3, 4, 0, 1 ];
            var r = 0;
            for(var i=0; i<dateIndices.length; i++){
                r = a[orderBy].charCodeAt(dateIndices[i]) - b[orderBy].charCodeAt(dateIndices[i]);
                if(r !== 0)
                    return r;
            }
            return r;
        }
    }
}

/**
 * stableSort
 * @param array
 * @param cmp
 */
function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

/**
 * getSorting
 * @param order
 * @param orderBy
 * @return {function(*=, *=): number}
 */
function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const headStyles = makeStyles(theme => ({
    headFont : {
        fontSize: 15,
        fontWeight : 600
    },
    fontBold: {
        fontWeight: 600
    }
}));

/**
 * EnhancedTableHead
 * @param props
 * @return {*}
 * @constructor
 */
function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };
    const headClasses = headStyles();

    const headRows = [
        { id: 'tradeDate', numeric: true, disablePadding: false, label: "İşlem Zamanı" },
        { id: 'tradeType', numeric: true, disablePadding: false, label: "İşlem Türü" },
        { id: 'platformName', numeric: false, disablePadding: false, label: "Platform Adı",  },
        { id: 'baseCurrency', numeric: false, disablePadding: false, label: "Gelen Kripto Varlık",  },
        { id: 'quoteCurrency', numeric: false, disablePadding: false, label: "Giden Kripto Varlık",  },
        { id: 'amount', numeric: true, disablePadding: false, label: "Gelen Kripto Varlık Miktarı" },
        { id: 'price', numeric: true, disablePadding: false, label: "Giden Kripto Varlık Miktarı" },
        { id: 'buyerCurrency', numeric: false, disablePadding: false, label: "Ödenen Komisyon",  },
        { id: 'buyerFee', numeric: true, disablePadding: false, label: "Ödenen Komisyon Miktarı" },
    ];

    return (
        <TableHead>
            <TableRow>
                {headRows.map(row => (
                    <TableCell
                        key={row.id}
                        style={row.style ? row.style : null}
                        align={row.numeric ? 'right' : 'left'}
                        padding={row.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === row.id ? order : false}
                        className={headClasses.headFont}
                    >
                        <TableSortLabel
                            active={orderBy === row.id}
                            direction={order}
                            onClick={createSortHandler(row.id)}
                        >
                        {
                            <div>{row.label}</div>
                        }
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}
EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
};

const useStyles = makeStyles(theme => ({
    table: {
        minWidth: 750,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    fontSize15:{
        fontSize: 15
    }
}));
/**
 * TransactionTradeInfo
 * @param props
 * @return {*}
 * @constructor
 */
export default function TransactionTradeInfo (props) {
    const classes = useStyles();
    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('tradeDate');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const rows = props.tradeList;
    const platformName = props.platformName;

    React.useEffect(() => {
        setPage(0);
        console.log(rows)
    }, [rows]);

    /**
     * handleRequestSort
     * @param event
     * @param property
     */
    function handleRequestSort(event, property) {
        const isDesc = orderBy === property && order === 'desc';
        setOrder(isDesc ? 'asc' : 'desc');
        setOrderBy(property);
    }

    /**
     * handleChangePage
     * @param event
     * @param newPage
     */
    function handleChangePage(event, newPage) {
        setPage(newPage);
    }

    /**
     * handleChangeRowsPerPage
     * @param event
     */
    function handleChangeRowsPerPage(event) {
        setRowsPerPage(+event.target.value);
        setPage(0);
    }
    
    /**
     * prepareItemArr
     * @param trArray
     * @return {setArray}
     */
    function prepareItemArr(trArray) {
        var setArray = [];
        for(var i=0;i<trArray.length;i++){
            var valueItem = {};
            valueItem.values = [];
            valueItem.values.push(trArray[i].tradeDate);
            valueItem.values.push(trArray[i].tradeType);
            valueItem.values.push(platformName);
            valueItem.values.push(trArray[i].baseCurrency);
            valueItem.values.push(trArray[i].quoteCurrency);
            valueItem.values.push(formatDecimal(trArray[i].amount));
            valueItem.values.push(formatDecimal(trArray[i].price));
            valueItem.values.push(trArray[i].buyerCurrency);
            valueItem.values.push(formatDecimal(trArray[i].buyerFee));
            setArray.push(valueItem);
        }
        return setArray;
    }  

    const headRows = [
        { id: 'tradeDate', numeric: true, disablePadding: false, label: "İşlem Zamanı" },
        { id: 'tradeType', numeric: true, disablePadding: false, label: "İşlem Türü" },
        { id: 'platformName', numeric: false, disablePadding: false, label: "Platform Adı",  },
        { id: 'baseCurrency', numeric: false, disablePadding: false, label: "Gelen Kripto Varlık",  },
        { id: 'quoteCurrency', numeric: false, disablePadding: false, label: "Giden Kripto Varlık",  },
        { id: 'amount', numeric: true, disablePadding: false, label: "Gelen Kripto Varlık Miktarı" },
        { id: 'price', numeric: true, disablePadding: false, label: "Giden Kripto Varlık Miktarı" },
        { id: 'buyerCurrency', numeric: false, disablePadding: false, label: "Ödenen Komisyon",  },
        { id: 'buyerFee', numeric: true, disablePadding: false, label: "Ödenen Komisyon Miktarı" },
    ];

     /**
     * downloadAsExcel
     * @param serviceName
     * @param fileName
     */
    function downloadAsExcel(requesyBody) {
        post(EXPORT_EXCEL_TRADES,requesyBody)
            .then(function (response) {
                DownloadUtils.downloadFileByContentExcel(response.data, "ALIM-SATIM İŞLEMLERİ RAPORU.xls", Globals.CONTENT_TYPE_EXCEL);
        })
        .catch(function (error) {
            checkHttpStatus(error,props.intl);
        })
    }

    const normalizeZero = (value, maxDecimal = 8) => {
        // null, undefined veya boş string kontrolü
        if (value === null || value === undefined || value === "") return "";
        
        // Tüm değer sıfırsa -> "0"
        if (/^0+(\.0+)?$/.test(value)) return "0";

        // Ondalık kısmı ayır
        const [intPart, decimalPart] = value.split(".");

        if (!decimalPart) return intPart; // ondalık yoksa integer döndür

        // Ondalık kısmı maxDecimal kadar al
        let trimmedDecimal = decimalPart.slice(0, maxDecimal);

        // Virgülden sonra sadece sıfırlar varsa boş bırak
        if (/^0+$/.test(trimmedDecimal)) return intPart;

        // Virgülden sonra son sıfırları kırp
        trimmedDecimal = trimmedDecimal.replace(/0+$/, "");

        return trimmedDecimal ? `${intPart}.${trimmedDecimal}` : intPart;
    };

    return (
                <div>    
                    <div className={classes.tableWrapper}>
                        <Table
                            className={classes.table}
                            aria-labelledby="tableTitle"
                            size={'medium'}
                        >
                            <EnhancedTableHead
                                order={order}
                                orderBy={orderBy}
                                onRequestSort={handleRequestSort}
                                rowCount={rows.length}
                                intl={props.intl}
                            />
                            <TableBody>
                            {stableSort(rows, getSorting(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                    return (
                                        <TableRow
                                            hover
                                            tabIndex={-1}
                                            key={row.name + index}
                                        >
                                            <TableCell align="right" key={"tradeDate_"+index}
                                                        id={"tradeDate_"+index}
                                                        className={classes.fontSize15}> {row.tradeDate}
                                                        </TableCell>    
                                            <TableCell component="th" key={"tradeType_"+index}
                                                       id={"tradeType_"+index}
                                                       className={classes.fontSize15}> {row.tradeType}
                                                       </TableCell>                                        
                                            <TableCell component="th" key={"platformName_"+index}
                                                       id={"platformName_"+index}
                                                       className={classes.fontSize15}> {platformName}
                                                       </TableCell>
                                            <TableCell component="th" key={"baseCurrency_"+index}
                                                       id={"baseCurrency_"+index}
                                                       className={classes.fontSize15}> {row.baseCurrency}
                                                       </TableCell>
                                            <TableCell component="th" key={"quoteCurrency_"+index}
                                                       id={"quoteCurrency_"+index}
                                                       className={classes.fontSize15}> {row.quoteCurrency}
                                                       </TableCell>

                                            <TableCell align="right" key={"amount_"+index}
                                                       id={"amount_"+index} className={classes.fontSize15}>
                                                <NumberFormat decimalScale={8}
                                                              isNumericString
                                                              fixedDecimalScale={false}
                                                              value={normalizeZero(row.amount)} decimalSeparator=','
                                                              thousandSeparator='.' displayType='text' />
                                            </TableCell>
                                            <TableCell align="right" key={"price_"+index}
                                                       id={"price_"+index} className={classes.fontSize15}>
                                                <NumberFormat decimalScale={8}
                                                              isNumericString
                                                              fixedDecimalScale={false}
                                                              value={normalizeZero(row.price)} decimalSeparator=','
                                                              thousandSeparator='.' displayType='text' />
                                            </TableCell>
                                            <TableCell component="th" key={"buyerCurrency_"+index}
                                                       id={"buyerCurrency_"+index} className={classes.fontSize15}>{row.buyerCurrency}
                                                       </TableCell>
                                            <TableCell align="right" key={"buyerFee_"+index}
                                                       id={"buyerFee_"+index} className={classes.fontSize15}>
                                                <NumberFormat decimalScale={8}
                                                              isNumericString
                                                              fixedDecimalScale={false}
                                                              value={normalizeZero(row.buyerFee)} decimalSeparator=','
                                                              thousandSeparator='.' displayType='text' />
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </div>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonText = {props.intl.formatMessage({id: "TABLE.PAGINATION.PREVIOUS"})}
                    nextIconButtonText = {props.intl.formatMessage({id: "TABLE.PAGINATION.NEXT"})}
                    labelRowsPerPage = {props.intl.formatMessage({id: "TABLE.PAGINATION.PER_PAGE"})}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />
                <DownloadButtons
                    pdfOnClick={() =>  { printThisPage(
                                            prepareItemArr(
                                            rows
                                            ),
                                            headRows,
                                            "Alım Satım İşlemlerim" 
                                        )}
                    }
                     excelOnClick={() => downloadAsExcel({platformName: platformName, tradeList:  rows})}
                />
            </div>
    )
}